// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__2S1b9","header":"Title_header__1DIuH","withBorder":"Title_withBorder__3sZeJ"};